import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dateReschedule, timeReschedule, reprogramacion1, reprogramacion2, reprogramacion3, reprogramacion4, reprogramacion5 } from '../../../Images/Images';
import { triangle } from '../../../Images/GenericSVG';
import { messageApiRequest, messageChangeState, messageToStateMachine, updateInfoCall } from '../../../redux/actions/A_messages_to_SM';
import { API_ENDPOINTS, USER_STATE, INTEGRATION } from '../../../constants';
import { Singleton } from '../../../js/Singleton';
import { Logger } from '../../../js/helpers/Logger.js'
import { validateOnlyNumbers } from '../../../js/helpers/Utils/Validations';
import SelectComponent from '../Others/SelectComponent';
import DateTimeSelection from '../Others/DateTimeSelection'
import TimerCountDown from '../Others/TimerCountDown'
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js'
import { messageNotifyAlreadyWrapUp, messageAgentRedy, messageChangeStateHelper } from '../../../js/helpers/helperMessages';
import SingletonWebSocket from '../../../js/Singletons/SingletonWebSocket';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import AlertModalActions from '../../../redux/actions/A_Alert_Modal';
import ContainerDataPreview from '../Others/ContainerDataPreview';
import {AgentButton, SearchSelectionAgent}  from 'global-components-library';
import { callIcon } from '../../../Images/Images';
import { UncontrolledTooltip } from 'reactstrap';
import { setNewPreviewTime } from '../../../redux/actions/A_preview';

class RateCall extends Component {
  constructor(props) {
    super(props);
    this.language = new Singleton();
    this.state = {
      selectionReschedule: 1,
      otherPhoneReschedule: "",
      dateReturned: "",
      timeReturned: "",
      showWindowSelectDate: false,
      isReadyToSave: false,
      rateList: {},
      numbersList: [],
      subRateList: {},
      callbackDays: {},
      currentState: this.props.userState,
      selectedDisposition: 0,
      selectedSubdisposition: 0,
      dataCall: props.dataCall,
      canReprogram: false,
      displayedComponent: -1,
      selectedPhoneItem: null,
      withOutDisposition:false,
      isExitAssistedState: false,
      disabledBtnSaveDataPreview: true,
      isExitPreview: false,
      newDataPreview:{disabledUpdate:true,newArray:[]},
      isDisabled: false,
    };
    this.selectDate = false;
    this.iSelectedDisposition = 0;
    this.iSelectedSubDisposition = 0;
    this.CampaignCallBacks = [];
    this.arrayDispositions = {};
    this.arrayOnlyNums = {};
    this.errorOnPhoneNumberList = false;
    this.messageErrorNumberList = null;
    this.arrayNumsId = {};
    this.integrationAction = this.props.integrationAction;
    let APIFact = new APIFactory();
    this.sharedData = new SingletonSharedData();
    this.apiCont = APIFact.buildClient();
    this.date = new Date();
    this.stChangeState = null;
    this.attempts = 0;
    this.isPreview = this.sharedData.getDataPreviewPro().dialingMode === 1;
    this.integrationData=null;
  }
  componentDidMount() {
    this.props.setNewPreviewTime(this.props.preview.initPreviewTime)
    if (this.props.dispositionListInformation) {
      this.processInformation(this.props.dispositionListInformation);
    } else if (this.props.dispositionListError) {
      this.processError(this.props.dispositionListError);
    }
  }
  processInformation(objResponse) {
    Logger.Trace("[RateCall] ProcessInformation Begin ");
    this.errorOnPhoneNumberList = false;
    this.arrayDispositions = Object.keys(objResponse.Dispositions).map(i => objResponse.Dispositions[i]);
    this.arrayDispositions.sort((a,b) => a.Orden-b.Orden);

    if (objResponse.CampaignCallBacks) {
      this.CampaignCallBacks = objResponse.CampaignCallBacks;
    }

    let arraySub = this.arrayDispositions[0] ? Object.keys(this.arrayDispositions[0].SubDisposition).map(i => this.arrayDispositions[0].SubDisposition[i]) : {};
    let arrayDispositions = [];
    for (let disposition in objResponse.Dispositions){
      arrayDispositions.push(objResponse.Dispositions[disposition]);
    }
    arrayDispositions.sort((a,b)=>a.Orden-b.Orden);
    this.setState({
      rateList: this.arrayDispositions,
      isReadyToSave: (this.arrayDispositions.length === 1 && arraySub.length === 0),
      withOutDisposition: (this.arrayDispositions.length === 0)
    });
    var arrayCallBackDays = Object.keys(objResponse.CallBacksDays).map(i => objResponse.CallBacksDays[i]);
    this.setState({ callbackDays: arrayCallBackDays });

    var arrayNums = Object.keys(objResponse.Numbers).map(i => objResponse.Numbers[i]);
    this.arrayNumsId = {};
    this.arrayOnlyNums = {};
    this.arrayNumsId = arrayNums.map((item) => { return { number: item.Phone, id: item.Graphic } });
    if (arrayNums.length === 0) {
      this.setState({
        numbersList: [{ img: reprogramacion1, number: this.state.dataCall.Phone, id: 1 }],
        selectedPhoneItem: { img: reprogramacion1, number: this.state.dataCall.Phone, id: 1 }
      });
      this.arrayOnlyNums = [this.state.dataCall.Phone];
    } else {
      this.arrayOnlyNums = Object.keys(arrayNums).map(i => arrayNums[i].Phone);
      let imagesNumber = { "1": reprogramacion1, "2": reprogramacion2, "3": reprogramacion3, "4": reprogramacion4, "5": reprogramacion5 };
      arrayNums = arrayNums.map((item) => { return { img: imagesNumber[item.Graphic], number: item.Phone, id: item.Graphic } });
      arrayNums = arrayNums.filter((item) => { return item.number !== "" });
      this.setState({ numbersList: arrayNums, selectedPhoneItem: arrayNums[0] });
    }
    switch (this.integrationAction) {
      case INTEGRATION.GET_DISPOSITIONS_AND_NUMBERS:
        this.onDispositionsAndNumbers();
        this.props.resetIntegrationAction();
        this.props.onDispositionButton();
        break;
      case INTEGRATION.GET_PHONE_NUMBERS:
        this.onNumbers();
        this.props.resetIntegrationAction();
        this.props.onDispositionButton();
        break;
      case INTEGRATION.GET_CAMPAIGN_DISPOSITIONS:
      case INTEGRATION.GET_ACD_DISPOSITIONS:
      case INTEGRATION.GET_DISPOSITIONS:
        let integrationMessage = { client: "galatea", data: this.arrayDispositions, action: "Disposition", subaction: "onDispositions" };
        SingletonWebSocket.send(integrationMessage);
        this.props.resetIntegrationAction();
        this.props.onDispositionButton();
        break;
      case INTEGRATION.DISPOSITION:
      case INTEGRATION.SAVE_DISPOSITION:
        this.saveDispositionFromIntegration(this.props.messagesIntegrations.dataMessageIntegration);
        this.props.resetIntegrationAction();
        break;
      default:
        break;
    }
    Logger.Trace("[RateCall] ProcessInformation End");
  }
  processError(messageError){
      const type = messageError.Type;
      const code = messageError.InternalCode
      const error = this.language.getText(`${type.toLowerCase()}-${code}`);
      this.errorOnPhoneNumberList = true;
      let integrationMessage = { client: "galatea", data: { code, message: error }, action: "errorOnDispositionList" };
      SingletonWebSocket.send(integrationMessage);
      integrationMessage = { client: "galatea", data: { code, message: error }, action: "errorOnDispositionSelected" };
      SingletonWebSocket.send(integrationMessage);
      integrationMessage = { client: "galatea", data: { code, message: error }, action: "errorOnDispositionsPhonesList" };
      SingletonWebSocket.send(integrationMessage);
      this.messageErrorNumberList = { code, message: error };
      if (this.integrationAction && this.integrationAction === INTEGRATION.GET_PHONE_NUMBERS) {
        this.onNumbers();
      }

  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.dispositionListInformation && nextProps.dispositionListInformation !== this.props.dispositionListInformation) {
      this.processInformation(nextProps.dispositionListInformation);
    } else if (nextProps.dispositionListError && nextProps.dispositionListError !== this.props.dispositionListError) {
      this.processError(nextProps.dispositionListError);
    }
    this.setState({
      currentState: nextProps.userState,
      dataCall: nextProps.dataCall,
    });
    if (nextProps.messagesIntegrations.dataMessageIntegration) {
      switch (nextProps.messagesIntegrations.dataMessageIntegration.action) {
        case INTEGRATION.CALL_ACTION:
          if (nextProps.messagesIntegrations.dataMessageIntegration.callAction === INTEGRATION.GET_DISPOSITIONS_AND_NUMBERS) {
            this.onDispositionsAndNumbers();
          } else if (nextProps.messagesIntegrations.dataMessageIntegration.callAction === INTEGRATION.GET_PHONE_NUMBERS) {
            this.onNumbers();
          }
          break;
        case INTEGRATION.GET_CAMPAIGN_DISPOSITIONS:
        case INTEGRATION.GET_ACD_DISPOSITIONS:
        case INTEGRATION.GET_DISPOSITIONS:
          let integrationMessage = { client: "galatea", data: this.arrayDispositions, action: "Disposition", subaction: "onDispositions" };
          SingletonWebSocket.send(integrationMessage);
          break;
        case INTEGRATION.DISPOSITION:
        case INTEGRATION.SAVE_DISPOSITION:
            this.saveDispositionFromIntegration(nextProps.messagesIntegrations.dataMessageIntegration);
            this.props.resetIntegrationAction();
          break;
        default:
          break;
      }
    }
  }
  selectReschedule(selection) {
    this.setState({
      selectionReschedule: selection,
      otherPhoneReschedule: selection === 1 ? "" : this.state.otherPhoneReschedule
    });
  }
  showHideCalendar(evt, showedCalendar) {
    this.setState({ showWindowSelectDate: showedCalendar });
    evt.stopPropagation();
  }
  saveDispositionFromIntegration(dataMessageIntegration){
    if (!isNaN(dataMessageIntegration.DispositionId)) {
      let _this = this;
      Logger.Trace("receiving-----", dataMessageIntegration.DispositionId);
      _this.iSelectedDisposition = dataMessageIntegration.DispositionId;
      _this.iSelectedSubDisposition = dataMessageIntegration.SubId;
      let dispositionExists = _this.iSelectedDisposition in this.props.dispositionListInformation.Dispositions;
      const arraySubDisposition = dispositionExists ? this.props.dispositionListInformation.Dispositions[_this.iSelectedDisposition].SubDisposition: [];
      let canReprogram = dispositionExists ?
                            arraySubDisposition[_this.iSelectedSubDisposition] ?
                              arraySubDisposition[_this.iSelectedSubDisposition].CanReprogram
                                : this.props.dispositionListInformation.Dispositions[_this.iSelectedDisposition].CanReprogram
                                  : false;
      if (!canReprogram) {
        _this.saveDisposition();
      } else {
        if (dataMessageIntegration.subaction === INTEGRATION.RESCHEDULE_CALL_ACD) {
          _this.onReprogramCall();
          _this.saveDisposition(dataMessageIntegration);
        }
      }
    }
  }
  saveDisposition = (messagesIntegrations = null) => {
    this.setState({ isReadyToSave: false });
    this.sharedData.setIsRated(true);
    let now = new Date();
    let dif = now.getTime() - this.date.getTime();
    let dispositionId=parseInt(this.state.selectedDisposition !== 0 ? this.state.selectedDisposition : this.iSelectedDisposition);
    let exitAssistedMode=this.state.isExitAssistedState;
    let dispositionSelected=null;
    const permissionShowCalif = this.sharedData.getGeneralPermissions()[99];
    if (Object.keys(this.state.rateList).length > 0) {
      dispositionSelected=this.state.rateList.find(e=>(e.Id==dispositionId))
    } else if (this.props.dispositionListInformation && this.props.dispositionListInformation.Dispositions) {
      dispositionSelected=Object.values(this.props.dispositionListInformation.Dispositions).find(e=>(e.Id==dispositionId));
    }
    if (dispositionSelected) {
      exitAssistedMode=dispositionSelected.FinishPreview;
    }
    Logger.Trace(`[RateCall] onSaveDisposition CallId ´${this.state.dataCall.CallId}´ before ´${dif > 1000}´`);
    if (dif > 1000 || this.integrationAction || messagesIntegrations) {
      let objectData = {
        CallId: Math.abs(this.state.dataCall.CallId),
        DispositionId: dispositionId,
        Origin: '',
        CallKey: this.state.dataCall.CalKey,
        CallOutId: this.state.dataCall.CallOutId,
        SubId: this.state.selectedSubdisposition !== 0 ? this.state.selectedSubdisposition : this.iSelectedSubDisposition,
        CallType: this.state.dataCall.CallType,
        IsExitAssisted: exitAssistedMode,
        IsExitPreview: this.state.isExitPreview
        
      }
      this.props.messageApiRequest(API_ENDPOINTS.SAVE_DISPOSITION, objectData);
      let integrationMessage = { client: "galatea", data: objectData, action: "Disposition" };
      SingletonWebSocket.send(integrationMessage);
      Logger.Debug("The SaveDisposition button was clicked by the agent!");
      Logger.Debug("saveDisposition:", messagesIntegrations);
      if (this.state.dateReturned !== "" || (messagesIntegrations && messagesIntegrations.subaction === INTEGRATION.RESCHEDULE_CALL_ACD)) {
        this.rescheduleCall(messagesIntegrations);
      }
      this.stChangeState = setTimeout(() => {
        Logger.Trace("saveDisposition currentState:" + this.state.currentState);
        if (this.state.currentState === USER_STATE.WRAPUP) {
          permissionShowCalif !== '2' && this.props.messageChangeState();
        } else {
          this.props.messageToStateMachine(messageNotifyAlreadyWrapUp());
        }
      }, 1000);
      setTimeout(() => {
        this.setState({ isReadyToSave: true , isExitAssistedState: exitAssistedMode})
      }, 3000);
      this.props.onDispositionButton();
    }
  }
  rescheduleCall(messagesIntegrations = null) {
    let objCallBack;
    if (messagesIntegrations && messagesIntegrations.subaction === INTEGRATION.RESCHEDULE_CALL_ACD) {
      let arrayNums = this.arrayNumsId.filter((item) => { return item.number === messagesIntegrations.TelReprograma });
      objCallBack = {
        CamId: messagesIntegrations.CamId,
        Phone: messagesIntegrations.TelReprograma,
        TelReprograma: arrayNums[0] ? (arrayNums[0].id = ! "" ? arrayNums[0].id : 0) : 0,
        IsAuto: false,
        DateDial: messagesIntegrations.DateDial
      }
    } else {
      var date = this.state.dateReturned + " " + this.state.timeReturned;
      var phone = this.state.selectionReschedule === 2 ? this.state.otherPhoneReschedule : this.state.selectedPhoneItem.number;
      var telReprogram = this.state.dataCall.CallType === 1 ? 1 : this.state.selectionReschedule === 2 ? 0 : this.state.selectedPhoneItem.id;
      objCallBack = {
        CamId: this.state.dataCall.Id,
        Phone: phone,
        TelReprograma: telReprogram,
        IsAuto: false,
        DateDial: date
      }
    }
    this.rescheduleCallRequest(objCallBack);
  }
  rescheduleCallRequest(params) {
    let _this = this;
    setTimeout(function () {
      _this.props.messageApiRequest(API_ENDPOINTS.CALL_BACK, params);
    }, 500);
    const integrationMessage = { client: "galatea", action: "Disposition", subaction: "onReprogramSuccess" };
    SingletonWebSocket.send(integrationMessage);
  }
  selectRate(item) {
    let index = this.state.rateList.findIndex( s => s.Id === item.Id );
    this.arraySubDisposition = Object.keys(this.state.rateList[index].SubDisposition).map(i => this.state.rateList[index].SubDisposition[i]);
    this.arraySubDisposition.sort((a,b) => a.Orden-b.Orden);
    let selectedSubdisposition = this.arraySubDisposition.length === 1 ? 0 : -1;
    let canReprogram = this.arraySubDisposition[selectedSubdisposition] ? this.arraySubDisposition[selectedSubdisposition].CanReprogram : this.state.rateList[index].CanReprogram;
    this.setState({
      subRateList: this.arraySubDisposition,
      selectedDisposition: item.Id,
      selectedSubdisposition: this.arraySubDisposition.length === 1 ? 0 : -1,
      canReprogram: canReprogram,
      isReadyToSave: this.arraySubDisposition.length < 2,
      isExitAssistedState: item.FinishPreview,
      isExitPreview: item.FinishRecordPreview
    })
  }
  selectSubRate(item) {
    this.setState({
      selectedSubdisposition: item.Id,
      canReprogram: item.CanReprogram,
      isReadyToSave: true,
    });
  }
  displaying(compSelected) {
    this.setState({ displayedComponent: compSelected });
  }
  dateSelected(date, time) {
    this.setState({
      showWindowSelectDate: false,
      dateReturned: date,
      timeReturned: time,
    });
  }
  onReprogramCall() {
    const period = this.sharedData.getGeneralPermissions()[35];
    const today = new Date();
    let limit = new Date();
    limit.setDate(limit.getDate() + parseInt(period, 10));
    let callBacks=this.CampaignCallBacks.filter(data => data.año==today.getFullYear() && (data.mes==today.getMonth()+1 ) && data.dia==today.getDate());
    const message = {
      callBacks: callBacks,
      startDate: this.parseDate(today),
      hasCallbacks: callBacks.length>0 ? true : false
    }
    const integrationMessage = { client: "galatea", data: message, action: "Disposition", subaction: "onReprogramCall" };
    SingletonWebSocket.send(integrationMessage);
  }
  parseDate(date) {
    let year = date.getFullYear();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    return year + "/" + month + "/" + day;
  }
  parseTime(time) {
    let hours = time.getHours();
    let minutes = ('0' + time.getMinutes()).slice(-2);
    let seconds = ('0' + time.getSeconds()).slice(-2);
    return hours + ":" + minutes + ":" + seconds;
  }
  onDispositionsAndNumbers() {
    let data = {
      dispositions: this.arrayDispositions,
      phoneNumbers: this.arrayOnlyNums
    }
    let integrationMessage = { client: "galatea", data: data, action: "Disposition", subaction: "onDispositionsAndNumbers" };
    SingletonWebSocket.send(integrationMessage);
  }
  onNumbers() {
    if (this.errorOnPhoneNumberList) {
      let integrationMessage = { client: "galatea", data: this.messageErrorNumberList, action: "errorOnPhoneNumbersList" };
      SingletonWebSocket.send(integrationMessage);
    } else {
      let integrationMessage = { client: "galatea", data: this.arrayOnlyNums, action: "Disposition", subaction: "onPhoneNumbers" };
      SingletonWebSocket.send(integrationMessage);
    }
  }
  onUpdateCallKey(callKey){
    if(callKey !== '' && this.props.dataCall.CalKey !== callKey){
      
      this.setState({ dataCall: { ...this.state.dataCall, CalKey: callKey } });
    
      let objectData = {
        CallId: this.state.dataCall.CallId,
        CallKey: callKey,
        CallType: this.state.dataCall.CallType
      }
      
      this.props.messageApiRequest(API_ENDPOINTS.UPDATE_CALL_KEY, objectData);
    }
  }

  OnKeyPressEvent = (e) => {
		var r = /[!¡@#$%^&*()_+\-=\[\]{};':"\\|¬´°¨,.<>\/?]+$/;
		if (e.charCode !== 8) {
			if (r.test(String.fromCharCode(e.charCode))) {
				e.preventDefault();
			}
		}
	};

  getNormalWrapupWindow() {
    const styleForPreview = this.isPreview? '_wrapup':'';
    const disabledOption = !this.props.editableCallKey ? 'disabled' : '';
    return <div className="dataPreviewAndRate fullSize scroll">
     <div className={`callWindowContainer ${styleForPreview}`} onClick={(e) => this.showHideCalendar(e, false)} >
     <div className={'rateCallWindow'}>
          {this.state.currentState === USER_STATE.WRAPUP && <TimerCountDown
            showingTimer={this.state.currentState === USER_STATE.WRAPUP}
            timeToRate={this.props.dispositionTime}
            lineWidth={6}
            colorDown={"#FFB427"}
            colorUp={"#BA5D00"}
            size={60}
            fontsize={"one"} 
            onTimesUp={() => {
              this.props.messageChangeState();
            }}
            />
          }
          <p className="titleRateCall">{this.language.getText("CallControlcallCalificationtitle")}</p>
          {Object.keys(this.state.rateList).length > 0 && (
            <div>
               {!this.isPreview && <div className='rateCallFirstContainer'>
                <div className={`rateCallCallKeyOption ${disabledOption}`}>
                  <img className='callKeyIcon' src={callIcon} alt='icon'></img>
                  <div className='separatorIcon'></div>
                  <input
                    type='text'
                    className='txtDataClient'
                    defaultValue={this.props.dataCall.CalKey}
                    placeholder={this.language.getText('GUICallSpacecallkey')}
                    readOnly={!this.props.editableCallKey}
                    maxLength={40}
                    onKeyPress={this.OnKeyPressEvent}
                    onBlur={event => this.onUpdateCallKey(event.target.value)}
                  />
                </div>
                <div className='rateCallIconInfo'>
                  <i class="gcl-icon info" id='idTooltip'></i>
                  <UncontrolledTooltip placement='top-start' target={'idTooltip'} hideArrow className='gcl-labelInput-tooltip'>
                    {`${this.language.getText('CallControlcallCalificationcall-key-tooltip1')}\n${this.language.getText('CallControlcallCalificationcall-key-tooltip2')}`}
                  </UncontrolledTooltip>
                </div> 
              </div>}
              <div className="rateCallContainer">
                <SearchSelectionAgent options={this.state.rateList} noDefault sort ignoreCase placeholder={this.language.getText("CallControlCRMxcontrolsselectAnOption")} filterBy={'Description'} onSelected={item =>  this.selectRate(item)}/> 
              </div>
              {Object.keys(this.state.subRateList).length > 0 &&
              <div className="rateCallContainer">
                <SearchSelectionAgent noDefault sort ignoreCase options={this.state.subRateList}  placeholder={this.language.getText("CallControlCRMxcontrolsselectAnOption")} filterBy={'Description'} onSelected={item =>  this.selectSubRate(item)}/> 
              </div>}
            </div>
          )}
        </div>
        {this.state.canReprogram &&
          <div className="rescheduleWindow">
            <div className="rescheduleSelector">
              <div className={"rescheduleRadioButton" + (this.state.selectionReschedule === 1 ? " active" : " inactive")} onClick={() => this.selectReschedule(1)}></div>
              <div className="containerReschedule">
                <SelectComponent
                  disabled={this.state.selectionReschedule !== 1}
                  bottomBox={60}
                  defaultDiv={{ item: "texSelection" }}
                  displayer={"bigDisplayer"}
                  customCell={"cellImageText"}
                  parameters={{ image: "img", text: "number" }}
                  dataSource={this.state.numbersList}
                  closeOthers={true}
                  itemDefault={0}
                  tag={"3"}
                  displayedList={this.state.displayedComponent}
                  onDisplayList={(compSelected) => this.displaying(compSelected)}
                  onSelectItem={(itemSelected) => this.setState({ selectedPhoneItem: itemSelected })} />
              </div>
            </div>
            <div className="breakLine"></div>
            <div className="rescheduleSelector">
              <div className={"rescheduleRadioButton" + (this.state.selectionReschedule === 2 ? " active" : " inactive")} onClick={() => this.selectReschedule(2)}></div>
              <input type="text"
                placeholder={this.language.getText("GUISearchWindowphoneNum")}
                disabled={this.state.selectionReschedule === 1}
                className={"otherPhoneReschedule" + (this.state.selectionReschedule === 2 ? " active" : " inactive")}
                value={this.state.otherPhoneReschedule}
                onChange={event => { this.setState({ otherPhoneReschedule: event.target.value }) }}
                onKeyPress={validateOnlyNumbers} />
            </div>
            <div className="breakLine"></div>
            <div className="containerDate" onClick={(e) => this.showHideCalendar(e, !this.state.showWindowSelectDate)}>
              <div className="timeReschedule dateReschedule">
                <img className="iconDateReschedule" src={dateReschedule} alt="icon"></img>
                <p className="textDateReschedule">{this.state.dateReturned !== "" ? this.state.dateReturned : this.language.getText("CallControlcallCalificationdate")}</p>
              </div>
              <div className="timeReschedule">
                <img className="iconDateReschedule" src={timeReschedule} alt="icon"></img>
                <p className="textDateReschedule">{this.state.timeReturned !== "" ? this.state.timeReturned : this.language.getText("CallControlcallCalificationhour")}</p>
              </div>
              <div className="arrowButton arrowOnly">{triangle}</div>
            </div>
          </div>}
        {this.state.showWindowSelectDate &&
          <div className={`dateTimeContainer ${this.isPreview ? "preview" : ""}`}>
            <DateTimeSelection
              onSelectDate={(date, time) => this.dateSelected(date, time)}
              dataSource={this.state.callbackDays} 
            />
          </div>}
        <div className="rescheduleWindow">
          {this.isPreview ?
            <div className='containerBtnsPreview '>
              <AgentButton type='secondary' disabled={this.state.newDataPreview.disabledUpdate} onClick={()=>this.SendDataPreview()}>{this.language.getText("CallControlGUIContactDatabuttom")}</AgentButton>             
              <AgentButton type='primary' disabled={!this.state.isReadyToSave} onClick={()=>this.endWraUpWithDisp()}>{this.language.getText("CallControlCRMxcontrolssaveAllButton")}</AgentButton>
            </div>
            : <div
              className={"buttonSave " + (this.state.isReadyToSave ? "" : "disabled")}
              tabIndex="4"
              onClick={this.saveDisposition}
              disabled={!this.state.isReadyToSave}>
              {this.language.getText("CallControlCRMxcontrolssaveAllButton")}
            </div>
            
          }         
        </div>
      </div>
    
     {this.isPreview &&
     <ContainerDataPreview
        data={this.props.preview.data}
        headers={this.props.preview.headers}
        updateDataCallPreview={this.updateDataCallPreview}
        userState={this.state.currentState}
        callKey={this.props.preview.callKey}
        onChangeData={r => this.setState({newDataPreview:r})}
        disableInput={!this.props.preview.permissionUpdate}
       />
     }
     </div>
  }
  
  SendDataPreview(){
    let temp = [...this.state.newDataPreview.newArray]
    while(temp.length < 15)
    {
      temp.push('');
    };
    let dataPrev = {
      callKey: this.state.dataCall.CalKey,
      camID: this.state.dataCall.Id,
      newData: temp,
      callOutId: 0
    }
    this.updateDataCallPreview(dataPrev);
  }
  SendRateAndData(){
    this.SendDataPreview();
    setTimeout(() => this.saveDisposition(), 2000);
  }
  endWraUpWithoutDisp(){
    if(!this.state.newDataPreview.disabledUpdate)
    {
      this.props.showAlertModal({
        type: "ModalAlert",
        title: this.language.getText("CallControlcallCalificationfinishWrapup"),
        message: this.language.getText("GUIAlertMessageexitWrapUpMsgConfirmation"),
        button: this.language.getText("GUIAlertMessagefinish-and-update-btn"),
        secondButton: this.language.getText("GUIAlertMessagefinish-only-btn"),
        buttonFun: () => this.SendDataAndExitWrapUp(),
        secondButtonFtn: () => this.finishProblemWrapupTime()
      })
    }else{
      this.finishProblemWrapupTime();
    }
  }

  endWraUpWithDisp (){
    if(!this.state.newDataPreview.disabledUpdate)
    {
      this.props.showAlertModal({
        type: "ModalAlert",
        title: this.language.getText("CallControlcallCalificationsave-disposition-title"),
        message: this.language.getText("GUIAlertMessageexitWrapUpMsgConfirmation"), 
        button: this.language.getText("CallControlcallCalificationsave-and-update-btn"),
        secondButton: this.language.getText("CallControlcallCalificationsave-only-btn"),
        buttonFun: () => this.SendRateAndData(),
        secondButtonFtn: () => this.saveDisposition()
      })
    }else{
      this.saveDisposition()
    }
  }

  SendDataAndExitWrapUp(){
    this.SendDataPreview();
    setTimeout(()=>this.props.messageToStateMachine(messageAgentRedy()),3000);
  }
  finishProblemWrapupTime() {
    this.props.messageToStateMachine(messageChangeStateHelper())
  }
  getProblemWrapupWindow() {
    { return this.sharedData.getDataPreviewPro().dialingMode === 0 ?
      <div className={"rateUnefectiveCallWindow"}>
        <TimerCountDown
          showingTimer={this.state.currentState === USER_STATE.WRAPUP}
          timeToRate={this.props.dispositionTime}
          lineWidth={6}
          colorDown={"#FFB427"}
          colorUp={"#BA5D00"}
          size={90}
          fontsize={"one"} 
          onOneSecondRemaining={() => this.setState({ isDisabled: true })}/>
        <div className="breakLine"></div>
        {this.state.withOutDisposition === false && <p className={"titleUnefectiveCall"}>{this.language.getText("CallControlcallCalificationineffectiveCallTitle")}</p>}
        {this.state.withOutDisposition === false && <div className={"textUnefectiveCall"}>{this.language.getText("CallControlcallCalificationineffectiveCallMessage")} </div>}
        <br />
        { this.state.currentState !== USER_STATE.OTHER &&
          <button
            className={"buttonUnefectiveCall"}
            tabIndex="4"
            onClick={() => this.finishProblemWrapupTime()}
            disabled={this.state.isDisabled}>
            {this.language.getText("CallControlcallCalificationineffectiveCallBtn")}
          </button>
        }
      </div>     
      :
        <div className="dataPreviewAndRate">
          <div className={"rateCallWindowPreview"}>
                <TimerCountDown
                showingTimer={this.state.currentState === USER_STATE.WRAPUP}
                timeToRate={this.props.dispositionTime}
                lineWidth={6}
                colorDown={"#FFB427"}
                colorUp={"#BA5D00"}
                size={60}
                fontsize={"one"} />                      
              <div className='containerBtnsPreview'>
                  <AgentButton type='secondary' disabled={this.state.newDataPreview.disabledUpdate} onClick={()=>this.SendDataPreview()}>{this.language.getText("CallControlGUIContactDatabuttom")}</AgentButton>          
                  <AgentButton type='primary' color={'yellow'} onClick={()=>this.endWraUpWithoutDisp()}>{this.language.getText("CallControlcallCalificationfinishWrapup")}</AgentButton>
              </div>
          </div>
          <ContainerDataPreview
            data={this.props.preview.data}
						headers={this.props.preview.headers}
            updateDataCallPreview={this.updateDataCallPreview}
            userState={this.state.currentState}
            callKey={this.props.preview.callKey}
            onChangeData={r => this.setState({newDataPreview:r})}
            disableInput={!this.props.preview.permissionUpdate}
            />
          </div>
      }
  }

  componentWillUnmount() {
    clearTimeout(this.stChangeState);
    const { rateList, subRateList, canReprogram, showWindowSelectDate, isReadyToSave, dataCall } = this.state;
    Logger.Trace("[RateCall] stateValues:", {
      CallId: dataCall.CallId,
      rateList: Object.values(rateList),
      subRateList: Object.values(subRateList),
      canReprogram,
      showWindowSelectDate,
      isReadyToSave
    })
  }

  updateDataCallPreview=(data)=>{
    this.props.updateInfoCall(data.callKey, data.camID, data.newData, data.callOutId);
  }
  render() {
    return (
      <div className="conteinerCallSpace containerDataPreviewAndRate">
        { (this.props.problemInManualCall || this.state.withOutDisposition) ? this.getProblemWrapupWindow() : this.getNormalWrapupWindow() }
        </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    messagesIntegrations: state.messagesIntegrations,
    preview: state.preview
  }
}
function mapDispatchToProps(dispatch) {
  const { showAlertModal } = AlertModalActions.creators;
  return ({
    messageToStateMachine: (message) => { dispatch(messageToStateMachine(message)); },
    messageApiRequest: (subaction, json) => { dispatch(messageApiRequest(subaction, json)); },
    messageChangeState: () => { dispatch(messageChangeState()); },
    showAlertModal: payload => {
      dispatch(showAlertModal(payload));
    },
    updateInfoCall: (callKey_A, camID_A, phoneNumber_A, dataUsers_A, callOutId_A) => { dispatch(updateInfoCall(callKey_A, camID_A, phoneNumber_A, dataUsers_A, callOutId_A)) },
    setNewPreviewTime: (time) => {dispatch(setNewPreviewTime(time));}
  });
}
export default RateCall = connect(
  mapStateToProps,
  mapDispatchToProps
)(RateCall);



// WEBPACK FOOTER //
// ./src/components/workSpace/CallComponents/RateCall.jsx